<script setup>

import NavButton from '../components/NavButton.vue'
import SavingsTableRow from '../components/SavingsTableRow.vue'
import {computed} from "vue";
import { store } from "@/store";

const props = defineProps({
  title: String,
})

const annualSavingsRound = computed(() => {
  const { state, personal, dc, db, other } = store.formData.savings;
  return {
    state: parseInt(state.totalAnnual),
    personal: parseInt(personal.totalAnnual),
    dc: parseInt(dc.totalAnnual),
    db: parseInt(db.totalAnnual),
    other: parseInt(other.totalAnnual),
  }

})
</script>

<template>
    <div class="page__retirement-savings">
        <h2>{{ props.title }}</h2>
        <div class="row">
            <div class="col-md-6 body-text">
                <slot></slot>
            </div>
            <div class="col-md-6">
                <p class="callout-box">You have modelled your target Retirement Living Standard to be £{{ store.formData.standardTotal.value }} per week with a Selected Retirement Age of {{ store.formData.user.sra }} years. Add your current retirement savings below to see if you are on track to achieve this level of Retirement Standard.</p>
                <!-- <div class="nav-bar">
                    <NavButton dir=">" class="no-pn pink" v-on:click="formState.modal = 'addSaving'">Add a retirement saving</NavButton>
                </div> -->
                <div class="savings-table">
                  <table>
                    <tbody>
                      <SavingsTableRow v-bind:formState="store.formState" v-bind:value="annualSavingsRound.state" type="state">Your State Pension</SavingsTableRow>
                      <SavingsTableRow v-bind:formState="store.formState" v-bind:value="annualSavingsRound.personal" type="personal">Estimated annual income from your Personal Account at age {{ store.formData.user.sra }}</SavingsTableRow>
                      <SavingsTableRow v-bind:formState="store.formState" v-bind:value="annualSavingsRound.dc" type="dc">Estimated annual income from your other defined contribution retirement savings at age {{ store.formData.user.sra }}</SavingsTableRow>
                      <SavingsTableRow v-bind:formState="store.formState" v-bind:value="annualSavingsRound.db" type="db">Estimated annual income from your defined benefit retirement savings at age {{ store.formData.user.sra }}</SavingsTableRow>
                      <SavingsTableRow v-bind:formState="store.formState" v-bind:value="annualSavingsRound.other" type="other">Estimated annual income from any other sources at age {{ store.formData.user.sra }}</SavingsTableRow>
                    </tbody>
                  </table>
                </div>
                <div class="nav-bar">
                    <NavButton dir="<" v-on:click="store.formState.page = 'customStandard'">Create my own Retirement Living Standard</NavButton>
                    <NavButton dir=">" v-on:click="store.formState.page = 'myResults'" v-bind:disabled="store.formData.savingsTotal.annual === 0 && store.formData.savings.state.totalAnnual === 0">Finish and see my results</NavButton>
                </div>
            </div>
        </div>
    </div>
</template>
